import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import "./NewArticle.css";
import FormFieldValidationError from "../../../Common/FormFieldValidationError/FormFieldValidationError";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../configuration";
import Redirect from "react-router-dom/es/Redirect";
import {toast} from "react-toastify";
import {css} from "glamor";
import ReactQuill, {ComponentProps as Editor} from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import "../ViewAllArticles/ViewAllArticles.css";
import {Link} from "react-router-dom";

class NewArticle extends Component {

    constructor(props) {
        super(props);
        let today = new Date();
        let date = today.getFullYear() + ' 年 ' + (today.getMonth() + 1) + ' 月 ' + today.getDate() + ' 日';

        this.state = {
            title: "",
            body: "",
            bodyError: "",
            titleError: "",
            date: date,
            redirect: false

        };
        this.saveArticle = this.saveArticle.bind(this);
        this.handleChange = this.handleChange.bind(this);

    }

    validateTitle = () => {
        let title = this.state.title;
        return (title !== "");
    };

    validateBody = () => {
        let body = this.state.body;
        return (body !== "");
    };

    onInputChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
            titleError: ""

        });
    };

    handleChange(value) {
        this.setState({body: value, bodyError: ""});

    }


    saveArticle() {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.post(RESOURCE_BASE_URL + 'api/admin/article/new'
            , {
                title: this.state.title,
                articleContent: this.state.body,
                author: this.props.userId
            }, axiosConfig)
            .then((res) => {
                // console.log("New article added", res);
                toast(<FormattedMessage id="app.new-article.success"
                                        defaultMessage="記事を保存しました。"
                                        description=""/>, {
                    className: css({
                        background: "#56a517 !important",
                        padding: "30px",
                        color: "black"
                    })
                });

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                toast(<FormattedMessage id="app.new-article.error"
                                        defaultMessage="保存中にエラーが発生しました。"
                                        description=""/>, {
                    className: css({
                        background: "#f3d725 !important",
                        padding: "30px",
                        color: "black"
                    })
                });
            });
    }

    onSubmit = event => {

        event.preventDefault();

        let titleError = "";
        let bodyError = "";

        let validationPassed = true;

        if (!this.validateTitle(event)) {
            validationPassed = false;
            titleError = "app.validation.new-article.invalid-title";
        }
        if (!this.validateBody(event)) {
            validationPassed = false;
            bodyError = "app.validation.new-article.invalid-body";
        }

        if (validationPassed) {

            this.saveArticle();
            setTimeout(() => {
                this.setState({
                    redirect: true
                })
            }, 2000);
            // this.props.handle(false);

        } else {

            this.setState({titleError, bodyError});
        }
    };

    render() {
        // const {redirect} = this.state;

        // if (redirect) {
        //     return <Redirect to='/admin/article/all'/>;
        // }

        let formats = [
            'header', 'font', 'size',
            'bold', 'italic', 'underline', 'strike', 'blockquote',
            'list', 'bullet', 'indent',
            'link', 'image', 'video'
        ];

        let modules = {
            toolbar: [
                [{'header': '1'}, {'header': '2'}, {'font': []}],
                [{size: []}],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{'list': 'ordered'}, {'list': 'bullet'},
                    {'indent': '-1'}, {'indent': '+1'}],
                ['link', 'image', 'video'],
                ['clean']
            ],
            clipboard: {
                // toggle to add extra line breaks when pasting HTML:
                matchVisual: false,
            }
        };
        return (
            <div className="inquiry-reply-content">
                <div className="inquiry-reply-div">

                    <div className="title-1 text-align-left">
                        インフォメーション作成
                    </div>

                    <hr/>
                    <div className="row">
                        <div className="inquiry-reply-row-margin">
                            <div className="col-md-2">
                                <div className="text-right resp-article-label">
                                    <label>
                                        <FormattedMessage id="app.new-article.date"
                                                          defaultMessage="Date"
                                                          description=""/>
                                    </label>
                                </div>
                            </div>
                            <div className="col-md-10 new-article-resp-padding-left">
                                {this.state.date}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="inquiry-reply-row-margin">
                            <div className="col-md-2">
                                <div className="text-right resp-article-label">
                                    <label>
                                        <FormattedMessage id="app.new-article.title"
                                                          defaultMessage="Title"
                                                          description=""/>
                                    </label>
                                </div>
                            </div>
                            <div className="col-md-10 new-article-resp-padding-left">
                                <input type="text"
                                       className="form-control input-sm"
                                       name="title"
                                       value={this.state.title}
                                       onChange={this.onInputChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2 web-spacer-div">&nbsp;</div>
                        <div className="col-md-10 new-article-error-resp">
                            <FormFieldValidationError errors={this.state.titleError}/>
                        </div>
                    </div>

                    <div className="row">
                        <div className="inquiry-reply-row-margin ">
                            <div className="col-md-2">
                                <div className="text-right resp-article-label">
                                    <label>
                                        <FormattedMessage id="app.new-article.body"
                                                          defaultMessage="Article Body"
                                                          description=""/>
                                    </label>
                                </div>
                            </div>
                            <div className="col-md-10 editor-div new-article-resp-padding-left">
                                {/* <textarea rows="15" type="text"
                                              className="form-control article-area"
                                              name="body"
                                              value={this.state.body}
                                              onChange={this.onInputChange}
                                    />*/}
                                <ReactQuill name="body"
                                            value={this.state.body}
                                            formats={formats}
                                            modules={modules}
                                            onChange={this.handleChange}/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2 web-spacer-div">&nbsp;</div>
                        <div className="col-md-10 new-article-error-resp">
                            <FormFieldValidationError errors={this.state.bodyError}/>
                        </div>

                    </div>

                    <div className="row">
                        <div className="inquiry-reply-row-margin">

                            <div className="col-md-12 article-btn-left text-right-article">

                                <button className="btn btn-primary" onClick={this.onSubmit}>
                                    <FormattedMessage id="app.new-article.button"
                                                      defaultMessage="Add"
                                                      description=""/>
                                </button>

                            </div>
                        </div>
                        <br/>
                    </div>
                    <div className="row">
                        <div className='custom-col-12 set-padding-article'>
                            <div className="pull-right">
                                <Link to={"/admin/article/all"} className="">
                                    <FormattedMessage id="app.admin-info.back"
                                                      defaultMessage="<< Back"
                                                      description=""/>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        )

    }
}

export default NewArticle;



// WEBPACK FOOTER //
// ./src/components/Admin/Articles/NewArticle/NewArticle.js